import { useState } from 'react';

const SUBSCRIBE_URL = 'https://readdy.ai/api/form/da1gbpomlpfrg29fphl0';

const footNav = [
  { href: '#category', label: '题材分类' },
  { href: '#hot', label: '热门连载' },
  { href: '#guoman', label: '国漫专区' },
  { href: '#riman', label: '日漫专区' },
  { href: '#classic', label: '经典全本' },
  { href: '#faq', label: '常见问题' },
];

const hotTags = ['热血冒险', '恋爱甜宠', '奇幻异界', '悬疑烧脑', '搞笑日常', '都市现实', '历史古风', '科幻未来'];

export default function Footer() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honey = String(formData.get('website_alt') || '').trim();
    if (honey) {
      setStatus('success');
      setSuccessMsg('订阅成功，感谢你的关注。');
      return;
    }
    formData.delete('website_alt');

    setStatus('loading');
    setFormError('');
    try {
      const payload = new URLSearchParams(formData as unknown as Record<string, string>);
      const res = await fetch(SUBSCRIBE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || responseText || '';
      const isSpam =
        parsed?.code !== 'OK' &&
        (serverMsg.toLowerCase().includes('spam') || responseText.includes('form data is spam'));

      if (res.ok && parsed?.code === 'OK' && !isSpam) {
        form.reset();
        setStatus('success');
        setSuccessMsg('订阅成功，最新连载与分类动态会推送到你的邮箱。');
      } else {
        setStatus('error');
        setFormError(serverMsg || '订阅失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setFormError('网络异常，订阅失败，请稍后再试。');
    }
  };

  return (
    <footer className="w-full bg-secondary-800 text-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 + 订阅 */}
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2.5" aria-label="虫虫漫画">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-500 text-foreground-950">
                <i className="ri-bug-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-2xl">虫虫漫画</span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-6 text-background-100/80">
              国漫日漫分类大全，按题材类型整理热门连载与经典全本，
              帮你快速找到想看的漫画，追更找书都方便。
            </p>

            <form
              id="subscribe-form"
              data-readdy-form="订阅更新表单"
              onSubmit={onSubmit}
              className="mt-6 flex max-w-md flex-col gap-2 sm:flex-row sm:items-center sm:rounded-full sm:bg-secondary-700/70 sm:p-1.5"
            >
              <label htmlFor="footer-email" className="sr-only">
                邮箱订阅
              </label>
              <div className="flex flex-1 items-center gap-2 rounded-full bg-secondary-700/70 px-4 py-3 sm:bg-transparent sm:py-1.5">
                <i className="ri-mail-line text-background-100/70"></i>
                <input
                  id="footer-email"
                  name="email"
                  type="email"
                  required
                  placeholder="输入邮箱，订阅更新"
                  className="w-full bg-transparent text-sm text-background-50 outline-none placeholder:text-background-100/50"
                />
              </div>
              <button
                type="submit"
                disabled={status === 'loading'}
                className="whitespace-nowrap rounded-full bg-accent-500 px-5 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400 disabled:cursor-not-allowed disabled:opacity-60 sm:py-2.5"
              >
                {status === 'loading' ? '订阅中…' : '订阅更新'}
              </button>
            </form>
            {status === 'success' && (
              <p className="mt-3 flex items-center gap-2 text-sm text-accent-300">
                <i className="ri-checkbox-circle-line"></i>
                {successMsg}
              </p>
            )}
            {status === 'error' && (
              <p className="mt-3 flex items-center gap-2 text-sm text-primary-300">
                <i className="ri-error-warning-line"></i>
                {formError}
              </p>
            )}
            {/* 反垃圾蜜罐 */}
            <div className="footnote-skip" aria-hidden="true">
              <label>
                网站
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" readOnly />
              </label>
            </div>
          </div>

          {/* 快速导航 */}
          <div>
            <h3 className="text-sm font-bold text-background-50">快速导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {footNav.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-background-100/80 transition-colors hover:text-accent-300"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 热门题材 */}
          <div>
            <h3 className="text-sm font-bold text-background-50">热门题材</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {hotTags.map((t) => (
                <a
                  key={t}
                  href="#category"
                  className="whitespace-nowrap rounded-full border border-background-100/20 px-3 py-1 text-xs text-background-100/80 transition-colors hover:border-accent-400 hover:text-accent-300"
                >
                  {t}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-100/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-100/60">
            © {new Date().getFullYear()} 虫虫漫画 · 国漫日漫分类大全
          </p>
          <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-background-100/60">
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-line"></i> hello@chongchong-manhua.com
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-24-hours-line"></i> 每日 09:00 - 23:00
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}